import { FeatureItem } from '@dodao/web-core/types/features/spaceFeatures';

export const dodaoIoFeatures: FeatureItem[] = [];
